import React, { useState, useEffect } from 'react';
import GenericMenuCategoriesItems from '../Presentation/GenericMenuCategoriesItems';
import { isMobileDevice } from '../../../common/utilities/utils';
import MENU_CONSTANT from '../MenuConstants/MenuConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

export const GenericMenuCategoriesContainer = () => {
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { BROWSE_CATEGORIES } = MENU_CONSTANT;

  /**
   * Method calls on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listener for window size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  return (
    <div className='general-menu-container' data-testid='generic-component'>
      <div className='browse-parent d-flex mx-2'>
        <h2 className='browse'>{translateWithI18Next(BROWSE_CATEGORIES)}</h2>
        <div className='horizontal-line' />
      </div>
      <GenericMenuCategoriesItems className='' isMobile={isMobile} />
    </div>
  );
};

export default GenericMenuCategoriesContainer;
